import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setData } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setData(data);
      toast.success("Bem-vindo de volta!");
      navigate(data.company?.onboarding_done ? "/app" : "/app/onboarding");
    } catch (err) {
      toast.error(apiError(err, "E-mail ou senha incorretos."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
      <div className="mb-8"><Logo size="lg" /></div>
      <Card className="w-full max-w-md border-slate-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-display">Entrar</CardTitle>
          <CardDescription>Acesse sua conta GEPR</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" data-testid="login-email" type="email" required className="h-12"
                     value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@empresa.com.br" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Senha</Label>
              <Input id="password" data-testid="login-password" type="password" required className="h-12"
                     value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <Button type="submit" className="w-full h-12 bg-sky-600 hover:bg-sky-700 text-white active:scale-[0.98] transition-transform"
                    disabled={loading} data-testid="login-submit-btn">
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>
          <div className="mt-4 flex flex-col gap-2 text-sm text-center">
            <Link to="/recuperar-senha" className="text-sky-700 hover:underline" data-testid="forgot-password-link">
              Esqueci minha senha
            </Link>
            <span className="text-slate-500">
              Ainda não tem conta?{" "}
              <Link to="/cadastro" className="text-sky-700 font-medium hover:underline" data-testid="register-link">
                Começar grátis
              </Link>
            </span>
            <span className="text-xs text-slate-400 mt-2">
              Conta demo: demo@gepr.com.br · Gepr@Demo2026
            </span>
          </div>
        </CardContent>
      </Card>
      <Link to="/" className="mt-6 text-sm text-slate-500 hover:text-slate-800" data-testid="back-home-link">← Voltar ao site</Link>
    </div>
  );
}
